var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBookmarkAdded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Bookmark Added"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6625 9.10003L14.925 6.36252L16.2375 5.02502L17.6625 6.45002L21.1875 2.90002L22.525 4.23752L17.6625 9.10003ZM12 17.8L5.19995 20.7V3.22502H13.05V5.10002H7.07495V17.85L12 15.725L16.925 17.85V10.975H18.8V20.7L12 17.8Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmarkAdded);
export default __webpack_public_path__ + "static/media/icon-bookmark-added.1265e77e05376bdb111ccacbd2a66e65.svg";
export { ForwardRef as ReactComponent };